/**
 * Bottom padding (in pixels) applied during scroll.
 * Prevents the calendar from touching the viewport edge.
 */
const SCROLL_BOTTOM_PADDING = 20;

export const ensureElementVisible = (item: string | Element) => {
    setTimeout(() => {
        const element = typeof item === 'string' ? document.querySelector(item) : item;

        if (!element) return;

        const rect = element.getBoundingClientRect();
        const overflow = rect.bottom - window.innerHeight;

        if (overflow > 0) {
            window.scrollBy({
                behavior: 'smooth',
                top: overflow + SCROLL_BOTTOM_PADDING,
            });
        }
    }, 10);
};
